import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const onyphe = defineConnector({
  identifier: "onyphe",
  name: "ONYPHE",
  tagLine: "Internet reconnaissance and attack surface data",
  logo,
  protocol: "http",
  tags: ["security", "data"],
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an ONYPHE API key",
      items: [
        {
          kind: "markdown",
          content:
            "In ONYPHE, create or copy your API key and send it as a bearer token in the `Authorization` header.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://www.onyphe.io/api/v2/summary/ip/8.8.8.8",
  },
  defaultUrlPattern: () => "https://www\\.onyphe\\.io/.*",
});
